import { render } from "./Navbar-item.vue?vue&type=template&id=1c043514"
import script from "./Navbar-item.vue?vue&type=script&lang=js"
export * from "./Navbar-item.vue?vue&type=script&lang=js"

import "./Navbar-item.vue?vue&type=style&index=0&id=1c043514&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__